{
  "buttonLabel": "Mostrar sugerencias",
  "countAnnouncement": "{optionCount, plural, one {# opción} other {# opciones}} disponible(s).",
  "focusAnnouncement": "{isGroupChange, select, true {Se ha unido al grupo {groupTitle}, con {groupCount, plural, one {# opción} other {# opciones}}. } other {}}{optionText}{isSelected, select, true {, seleccionado} other {}}",
  "listboxLabel": "Sugerencias",
  "selectedAnnouncement": "{optionText}, seleccionado"
}
